/*
 *
 * LanguageProvider actions
 *
 */

import * as TaskManager from 'expo-task-manager';
import * as Location from 'expo-location';
import { Platform } from 'react-native';
import moment from 'moment';
import { CHANGE_USER_LOCATION, REMOVE_USER_LOCATION, SYNC_LOCATIONS } from './constants';
import store from '../../store';
import * as turf from '@turf/turf';
import login from '../../services/login';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Notifications from 'expo-notifications';
import request from '../../utils/request';
import API from '../../config/api';


const LOCATION_TRACKING = 'SB-location-tracking';
let entityRef = null;
// ✅ Define the background task ONCE at top level
TaskManager.defineTask(LOCATION_TRACKING, async ({ data, error }) => {
	if (error) {
		console.log('LOCATION_TRACKING task ERROR:', error);
		return;
	}
	// Check background location permission on every BG task run
	const bgPermission = await Location.getBackgroundPermissionsAsync();
	if (bgPermission.status !== 'granted') {
		console.log('Background location permission revoked, stopping tracking.');
		await Location.stopLocationUpdatesAsync(LOCATION_TRACKING);
		return;
	}

	if (data) {
		console.log(data, 'data'); // Use the data as needed

		const { locations } = data;
		if (locations.length) {
			const lat = locations[0].coords.latitude;
			const long = locations[0].coords.longitude;
			const location = {
				lat,
				lng: long,
				locationTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
				location: entityRef, // 👈 use the module-level variable
				type: "BgLocation",
			};

			const posted = await postLocations([location]);
			if (posted.status === 200) {
				store.dispatch(removeLocation());
			}

			store.dispatch(changeLocation(location));
		}
	}
});

async function postLocations(locations) {
	const url = `${API()}/geofence-service/log-geofence`;
	const posted = await request({
		url,
		method: 'POST',
		data: JSON.parse(JSON.stringify(locations)),
	});
	console.log(posted?.status, 'posted');
	
	return posted;
}

function changeLocation(location) {
	return {
		type: CHANGE_USER_LOCATION,
		location,
	};
}

function removeLocation(length) {
	return {
		type: REMOVE_USER_LOCATION,
		length,
	};
}


export function syncLocations() {
	return { type: SYNC_LOCATIONS };
}

export async function setEntityRef(entity) {
	entityRef = entity;
}
export async function stopLocationTracking() {
	if (Platform.OS !== 'web') {
		const tracking = await TaskManager.isTaskRegisteredAsync(LOCATION_TRACKING);
		if (tracking) {
			await Location.stopLocationUpdatesAsync(LOCATION_TRACKING);
			console.log('Location tracking stopped.');
		}
	}
}

export const startLocationTracking = async (timeInterval, distanceInterval) => {

	const hasStarted = await Location.hasStartedLocationUpdatesAsync(LOCATION_TRACKING);
	if (hasStarted) {
		console.log('Location tracking already started.');
		return;
	}

	await Location.startLocationUpdatesAsync(LOCATION_TRACKING, {
		accuracy: Location.Accuracy.Low,
		timeInterval: timeInterval, // 10 seconds
		distanceInterval: distanceInterval, // 10 meters
		foregroundService: {
			notificationTitle: 'Safe Buildings Tracking',
			notificationBody: 'Your location is monitored for safety and compliance.',
		},
	});
};

export const refreshLocationForegroundNotification = async (timeInterval = 10000, distanceInterval = 10) => {
	try {
		const bg = await Location.getBackgroundPermissionsAsync();
		if (bg.status !== 'granted') return;
		const hasStarted = await Location.hasStartedLocationUpdatesAsync(LOCATION_TRACKING);

		if (Platform.OS === 'android') {
			if (hasStarted) {
				await Location.stopLocationUpdatesAsync(LOCATION_TRACKING);
				await Location.startLocationUpdatesAsync(LOCATION_TRACKING, {
					accuracy: Location.Accuracy.Low,
					timeInterval,
					distanceInterval,
					foregroundService: {
						notificationTitle: 'Safe Buildings Tracking',
						notificationBody: 'Your location is monitored for safety and compliance.',
					},
				});
				console.log('Refreshed foreground service notification');
			} else {
				await startLocationTracking(timeInterval, distanceInterval);
			}
		} else {
			// iOS: no foreground notification; just ensure tracking is running
			if (!hasStarted) {
				await startLocationTracking(timeInterval, distanceInterval);
			}
		}
	} catch (e) {
		console.warn('Failed to refresh foreground notification', e);
	}
};

export async function trackUser(timeInterval = 10000, distanceInterval = 10) {
	console.log("1");
	if (Platform.OS === 'web') return;
	// entityRef = entity;
	try {
		// ✅ On Android 13+/14 require notification permission to start FGS
		if (Platform.OS === 'android') {
			const notifPerm = await Notifications.getPermissionsAsync();
			if (notifPerm?.status !== 'granted') {
				const req = await Notifications.requestPermissionsAsync();
				if (req?.status !== 'granted') {
					console.warn('Notification permission not granted; cannot start foreground location service.');
					return;
				}
			}
		}

		// ✅ Request foreground location permission
		const foreground = await Location.requestForegroundPermissionsAsync();
		if (foreground.status !== 'granted') {
			console.warn('Foreground location permission not granted');
			return;
		}

		// ✅ Optionally request background permission (if needed)
		const background = await Location.requestBackgroundPermissionsAsync();
		console.log('Background permission status:', background.status);

		if (background.status === 'granted') {
			const hasStarted = await Location.hasStartedLocationUpdatesAsync(LOCATION_TRACKING);
			if (!hasStarted) {
				await startLocationTracking(timeInterval, distanceInterval);
			} else if (Platform.OS === 'android') {
				// If already started and notification was dismissed, restart updates to re-show the notification
				await Location.stopLocationUpdatesAsync(LOCATION_TRACKING);
				await startLocationTracking(timeInterval, distanceInterval);
			}
		} else {
			console.warn('Background location permission not granted');
		}
	} catch (error) {
		console.error('Error requesting location permissions:', error);
	}
}


export async function sendCurrentLocation(locationId, type = "", entity = "", ref = "") {
	if (Platform.OS === 'web') return;
	try {

		const config = await login.getGlobalConfig();
		const user = await login.getUser();
		// Skip if geofencing is not enabled for the user
		if (user?.allowGeofencing === null || user?.allowGeofencing === false) {
			return;
		}
		switch (type) {
			case "CL":
				if (!config?.isChecklistTracking) {
					return;
				}
				break;
			case "DSR":
				if (!config?.isDSRTracking) {
					return;
				}
				break;
			case "IR":
				if (!config?.isIRTracking) {
					return;
				}
				break;

			default:
				break;
		}
		// ✅ Request foreground location permission
		const foreground = await Location.requestForegroundPermissionsAsync();
		if (foreground.status !== 'granted') {
			console.warn('Foreground location permission not granted');
			return;
		}

		// Get the current location
		const location = await Location.getCurrentPositionAsync({
			accuracy: Location.Accuracy.BestForNavigation,
		});
		if (location) {
			const lat = location.coords.latitude;
			const long = location.coords.longitude;
			const locData = {
				lat,
				lng: long,
				locationTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
				location: locationId, // 👈 use the module-level variable
				type,
				entity,
				ref, // Use the provided ref or the module-level variable
			};
			store.dispatch(changeLocation(locData));
		}
	} catch (error) {
		console.error('Error requesting location permissions:', error);
	}
}

const DISPATCH_INTERVAL = 3600000; // 1 hour in ms

export async function isPointInPolygon(polygonPoints, long, lat, locationId = "") {
	if (Platform.OS === 'web') return;
	try {
		const polygonCoords = polygonPoints.map(coord => {
			const [lat, lng] = coord.split(",").map(Number);
			return [lng, lat]; // GeoJSON format
		});
		polygonCoords.push(polygonCoords[0]); // Close polygon

		const polygon = turf.polygon([polygonCoords]);
		const point = turf.point([long, lat]);
		const isInside = turf.booleanPointInPolygon(point, polygon);

		// Read previous state from AsyncStorage
		const lastIsInsideStr = await AsyncStorage.getItem('lastIsInside');
		const lastDispatchTimeStr = await AsyncStorage.getItem('lastDispatchTime');
		const lastIsInside = lastIsInsideStr === null ? null : (lastIsInsideStr === 'true');
		const lastDispatchTime = lastDispatchTimeStr ? parseInt(lastDispatchTimeStr, 10) : 0;

		const now = Date.now();
		const shouldDispatch =
			lastIsInside === null || // first run
			isInside !== lastIsInside || // state changed
			(now - lastDispatchTime) > DISPATCH_INTERVAL; // 1 hour passed

		if (shouldDispatch) {
			const locData = {
				lat,
				lng: long,
				locationTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
				location: locationId,
				isInside: isInside,
				type: "GeoFence",
			};
			store.dispatch(changeLocation(locData));
			await AsyncStorage.setItem('lastDispatchTime', now.toString());
		}

		// Update lastIsInside in storage
		await AsyncStorage.setItem('lastIsInside', isInside ? 'true' : 'false');

		return isInside;
	} catch (error) {
		console.error('Error requesting location permissions:', error);
	}
}